<template>
  <v-card outlined class="pb-0 mx-2 my-3 mb-3">
    <v-toolbar flat>
      <v-toolbar-title class="mr-2 font-weight-bold">
        <slot name="title">Título</slot>
      </v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
    </v-toolbar>
    <v-divider></v-divider>

    <v-card-actions v-if="$slots.filtro">
      <slot name="filtro" class="pb-3"> Filtro </slot>
    </v-card-actions>

    <v-divider v-if="$slots.filtro"></v-divider>

    <div class="pb-2">
      <slot name="body" class="pb-3"> Cuerpo </slot>
    </div>

    <v-divider v-if="showDivider"></v-divider>

    <v-card-actions v-if="showDivider" class="justify-center py-2 d-flex">
      <slot name="actions"> Acciones </slot>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'LayoutSubModulo',

  data() {
    return {
      showDivider: false,
    };
  },

  mounted() {
    this.showDivider = this.$slots.actions !== undefined;
  },
};
</script>
